import type { Moment } from 'moment';
import { useEffect, useState } from 'react';
import { getRemainTime, momentTimezone } from 'src/utils/time';

interface RemainTime {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

const initialRemainTime: RemainTime = {
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00',
};

let remainTimeInterval;
const useRemainTimer = (): {
  remainTime: RemainTime;
  startTimer: ({ endTime, intervalTime }: { endTime: Moment; intervalTime?: number }) => void;
  endTimer: () => void;
  isEndTimer: boolean;
} => {
  const [remainTime, setRemainTime] = useState<RemainTime>(initialRemainTime);
  const [isEndTimer, setIsEndTimer] = useState(false);

  const clearTimer = () => clearInterval(remainTimeInterval);

  const startTimer = ({ endTime, intervalTime = 500 }: { endTime: Moment; intervalTime?: number }) => {
    setIsEndTimer(false);
    clearTimer();

    const updateTimer = () => {
      const [seconds, minutes, hours, days] = getRemainTime(momentTimezone(), endTime, 'days');
      setRemainTime({ days, hours, minutes, seconds });

      if (seconds === '00' && minutes === '00' && hours === '00' && days === '00') {
        endTimer();
      }
    };

    updateTimer();

    remainTimeInterval = setInterval(updateTimer, intervalTime);
  };

  const endTimer = () => {
    setRemainTime(initialRemainTime);
    setIsEndTimer(true);
    clearTimer();
  };

  useEffect(() => {
    return () => clearTimer();
  }, []);

  return { remainTime, startTimer, endTimer, isEndTimer };
};

export default useRemainTimer;
